jQuery(function ($) {
    function countdownTimer(duration, ddays, dhours, dminutes, dseconds, widget) {
        var timer = duration, days, hours, minutes, seconds;
        setInterval(function () {
            days = Math.floor(timer / (60 * 60 * 24));
            hours = Math.floor((timer % (60 * 60 * 24)) / (60 * 60));
            minutes = Math.floor((timer % (60 * 60)) / (60));
            seconds = Math.floor((timer % (60)));

            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            ddays.text(days);
            dhours.text(hours);
            dminutes.text(minutes);
            dseconds.text(seconds);

            if (--timer < 0) {
                widget.hide();
                timer = duration;
            }
        }, 1000);
    }

    $('.elementor-widget-container .countdown').each(function () {
        var widget = $(this);
        var timeDiff = $(this).data('timediff');
        var separatorColor = $(this).data('separator-color') != '' ? $(this).data('separator-color') : '#000';
        var tDay = $(`.elementor-widget-container .countdown.td-${timeDiff} .countdown-content>div:nth-child(1)>span:nth-child(1)`);
        var tHour = $(`.elementor-widget-container .countdown.td-${timeDiff} .countdown-content>div:nth-child(2)>span:nth-child(1)`);
        var tMin = $(`.elementor-widget-container .countdown.td-${timeDiff} .countdown-content>div:nth-child(3)>span:nth-child(1)`);
        var tSec = $(`.elementor-widget-container .countdown.td-${timeDiff} .countdown-content>div:nth-child(4)>span:nth-child(1)`);

        const style = document.createElement('style');

        style.textContent = `
        .elementor-widget-container .countdown.td-${timeDiff} .countdown-content>div:not(:last-child)::after { color: ${separatorColor}; }
        `;
     


        if (timeDiff > 0) {
            countdownTimer(timeDiff, tDay, tHour, tMin, tSec, widget);
            document.head.appendChild(style);
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/custom-elementor-widget/countdown-timer.js